
import VLabel from '~/components/ui/VLabel'
import VRadio from '~/components/ui/VRadio'
import VButton from '~/components/ui/VButton'
import VFormGroup from '~/components/ui/VFormGroup'
import BookingTime from '~/components/booking/BookingTime'
import CoworkingBookingLayout from '~/components/modals/booking/CoworkingBookingLayout'

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            date: '',
            selectedTypes: [],
            time: [{
                title: '09:00 PM',
                active: false,
                disabled: true,
            },{
                title: '10:00 PM',
                active: false,
                disabled: true,
            },{
                title: '11:00 PM',
                active: false,
                disabled: true,
            },{
                title: '12:00 PM',
                active: false,
                disabled: false,
            },{
                title: '13:00 PM',
                active: false,
                disabled: false,
            },{
                title: '14:00 PM',
                active: false,
                disabled: false,
            },{
                title: '15:00 PM',
                active: false,
                disabled: false,
            },{
                title: '16:00 PM',
                active: false,
                disabled: true,
            },{
                title: '17:00 PM',
                active: false,
                disabled: true,
            },{
                title: '18:00 PM',
                active: false,
                disabled: false,
            },{
                title: '19:00 PM',
                active: false,
                disabled: false,
            },{
                title: '20:00 PM',
                active: false,
                disabled: false,
            },{
                title: '21:00 PM',
                active: false,
                disabled: false,
            },{
                title: '22:00 PM',
                active: false,
                disabled: false,
            },{
                title: '23:00 PM',
                active: false,
                disabled: false,
            }],
            types: [{
                value: 'Screen',
                title: 'Screen'
            },{
                value: 'Laptop',
                title: 'Laptop'
            },{
                value: 'Board',
                title: 'Board'
            },{
                value: 'Mobile',
                title: 'Mobile'
            }],
        }
    },
    methods: {
        toggleTime(index) {
            const item = this.time[index]
            item.active = !item.active
        }
    },
    components: {
        VLabel,
        VRadio,
        VButton,
        VFormGroup,
        BookingTime,
        CoworkingBookingLayout
    }
}
